<!-- Create button template -->
<ng-template #createButtonTemplate>
  <mg-btn
    mat-button
    variant="filled"
    iconSet="minga"
    iconRight="down-toggle"
    [responsive]="true"
    [matMenuTriggerFor]="dropdownMenu">
    {{ MESSAGES.BUTTON_CREATE_NEW }}
  </mg-btn>
  <mat-menu
    #dropdownMenu="matMenu"
    xPosition="before">
    <button
      mat-menu-item
      [attr.data-analytics]="'hallpass-restrictions-click-create-npg'"
      (click)="upsertNoPartyGroup()">
      {{ MESSAGES.BUTTON_CREATE_NO_PARTY }}
    </button>
    <button
      mat-menu-item
      [attr.data-analytics]="'hallpass-restrictions-click-create-blackout'"
      (click)="_blackoutService.openEditModal({ isNewSchedule: true })">
      {{ MESSAGES.BUTTON_CREATE_BLACKOUT }}
    </button>
  </mat-menu>
</ng-template>

<div
  fxLayout="row"
  fxLayoutAlign.gt-sm="end end"
  [style.marginBottom]="'24px'">
  <ng-container *ngTemplateOutlet="createButtonTemplate"></ng-container>
</div>
<ng-container *ngTemplateOutlet="mainContentTemplate"></ng-container>

<!-- Page Content -->
<ng-template #mainContentTemplate>
  <div class="tw-flex tw-flex-column md:tw-flex-row tw-gap-8">
    <div class="left-content">
      <div class="tw-flex tw-flex-column tw-grow tw-gap-3">
        <div class="tw-flex tw-items-center tw-gap-1">
          <mg-text variant="header-md-secondary">{{ MESSAGES.NO_PARTY_GROUP_HEADER }}</mg-text>
          <mg-tooltip [label]="MESSAGES.NO_PASS_LISTS_TOOLTIP"></mg-tooltip>
        </div>
        <mg-membership-list-table
          [types]="noPartyLists"
          [descriptions]="false"
          [canChangeName]="true"
          [canChangeStatus]="true"
          [refreshList]="restrictionsService.refreshNoPartyGroupLists.asObservable()"
          [showDeniedPasses]="true"
          [flag]="NO_PARTY_FLAG"
          (navigateToDeniedPasses)="openDeniedPassesReport($event)"
          [editListFn]="upsertNoPartyGroup.bind(this)">
        </mg-membership-list-table>
      </div>
    </div>
    <div class="right-content">
      <div class="tw-flex tw-flex-column tw-grow tw-gap-3">
        <mg-text variant="header-md-secondary">{{ MESSAGES.NO_PASS_LISTS_HEADER }}</mg-text>
        <mg-membership-list-table
          [types]="noPassLists"
          [hideHeader]="true">
        </mg-membership-list-table>
      </div>
    </div>
  </div>

  <div class="spacer"></div>

  <mg-hpm-restrictions-blackout></mg-hpm-restrictions-blackout>
</ng-template>
